import {
  GET_PARTNERS_LIST,
  GET_PARTNERS_LIST_SUCCESS,
  GET_PARTNERS_LIST_FAILURE,
} from "./actionType";

// Actions

// Get Partners List
export const getPartnersList = () => {
  return {
    type: GET_PARTNERS_LIST,
  };
};

export const getPartnersListSuccess = (data) => {
  return {
    type: GET_PARTNERS_LIST_SUCCESS,
    payload: data,
  };
};

export const getPartnersListFailure = (error) => {
  return {
    type: GET_PARTNERS_LIST_FAILURE,
    payload: error,
  };
};
